import React, { useState,} from "react";
import { StyleSheet, TouchableOpacity } from 'react-native';

import { View } from '../../../components/Themed';
import { Entypo, Feather } from '@expo/vector-icons';
import Utilities from "../~Utilities/Utilities";
import { FontInfo } from "../~Utilities/Constants";
import { Data } from "../~Utilities/Data";
import QB from "./QB";
import OBNakedText from "../C_Text/OBNakedText";
import OBChange from "../C_Text/OBChange";
import { ConnectionMkt } from "../~Utilities/Connection";
// import OB from "./OB";
import OrderWoOrder from "../C_Popups/OrderWoOrder";

/*   -------------------------------------------------------------------   */

export interface IOBMaxButtonInfo
{
  expanded : boolean;             
}

/*   ====================================================================   */

export default class OBMaxButton extends React.Component<IOBMaxButtonInfo>
  {
  // const [m_index, setIndex]               = useState(iIndex);
  public orderWoOrderRef? : OrderWoOrder | null;

  /*   -------------------------------------------------------------------   */

  state = {expanded: false};

  /*   -------------------------------------------------------------------   */

  constructor(props)
  {
  super(props);

  this.state     = {expanded: this.props.expanded};
  this.Expanded  = this.Expanded.bind(this);
  
  }

/*   -------------------------------------------------------------------   */

 Expanded(bExpanded : boolean)
 {
 this.setState({expanded : bExpanded});
 }

 /*   --------------------------------------------------------------------   */

 render()
  {

    return(
      <Feather style={{backgroundColor:'transparent'}} name="maximize-2" size={20} color={this.state.expanded? FontInfo.sLightGreen : FontInfo.sDimGrayTp} />  
  
    );
  }

}



